import { render, staticRenderFns } from "./modelsTreeForTree.vue?vue&type=template&id=0881af36&scoped=true"
import script from "./modelsTreeForTree.vue?vue&type=script&lang=js"
export * from "./modelsTreeForTree.vue?vue&type=script&lang=js"
import style0 from "./modelsTreeForTree.vue?vue&type=style&index=0&id=0881af36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881af36",
  null
  
)

export default component.exports